module.exports = __webpack_public_path__ + "img/hdgz.ba472403.png";